import { render, staticRenderFns } from "./LuckyMoney.vue?vue&type=template&id=cca97516&scoped=true&"
import script from "./LuckyMoney.vue?vue&type=script&lang=js&"
export * from "./LuckyMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca97516",
  null
  
)

export default component.exports